import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {
  SAVE_RECENTLY_INTERACT_USERS,
  SAVE_USERS_RESUMES,
  SEND_RESUME
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import "@react-pdf-viewer/core/lib/styles/index.css";
import ShareModule from "../common/ShareModule";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import SaveIcon from "@mui/icons-material/Save";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ResumeBuilderTutorial from "../tutorial/ResumeBuilderTutorial";
import { English } from "../../constant/EnglishFallback";
import ShareResumeBuilder from "../tutorial/ShareResumeBuilder";
const ResumeDetailsModal = (props) => {
  const theme = useTheme();
  const { from } = props;
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId;
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [sendLoading, setSendLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [pdfTitle, setPdfTitle] = useState("");
  const [snackFlag, setSnackFlag] = useState(false);
  const [sendingFlag, setSendingFlag] = useState(false);
  const [tutorialIndex, setTutorialIndex] = useState(0);
  const [tutorialType, setTutorialType] = useState(null);
  const navigate = useNavigate();
  const [pdfTitleError, setPdfTitleError] = useState(false);

  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_SHARERESUME_HEADER = English.ResumeBuilder.TEXT_SHARERESUME_HEADER,
    TEXT_ENTER_TITLE = English.ResumeBuilder.TEXT_ENTER_TITLE,
    TEXT_SHARERESUME_TITLE = English.ResumeBuilder.TEXT_SHARERESUME_TITLE,
    TEXT_SAVE_RESUME_HEADER = English.ResumeBuilder.TEXT_SAVE_RESUME_HEADER,
    TEXT_MY_RESUME = English.ResumeBuilder.TEXT_MY_RESUME,
    TEXT_RESUME_TITLE = English.ResumeBuilder.TEXT_RESUME_TITLE,
    TEXT_SEND_RESUME = English.ResumeBuilder.TEXT_SEND_RESUME,
    BUTTON_BACK = English.ResumeBuilder.BUTTON_BACK,
    BUTTON_CREATE_RESUME = English.ResumeBuilder.BUTTON_CREATE_RESUME,
    TEXT_RESUME_COUNT_ERROR = English.ResumeBuilder.TEXT_RESUME_COUNT_ERROR,
    TEXT_SENDING = English.ResumeBuilder.TEXT_SENDING
  } = LanguageData || {};

  const handleSendResumeBuilder = async () => {
    setSendLoading(true);
    setSnackFlag(true);
    setSendingFlag(true);
    try {
      if (selectedEmails.length !== 0) {
        const obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: selectedEmails?.map((email) => ({
            Id: 0,
            UserId: Number(currentUserId),
            SharedWithEmail: email?.contactEmail,
            ResumePdf: props?.resumeData,
            ModifiedBy: Number(currentUserId)
          }))
        };
        const sendResumeResponse = await Postrequestcall(SEND_RESUME, obj, loginData?.accessToken);
        if (sendResumeResponse?.data?.message === "OK") {
          const interactionRequests = selectedEmails
            ?.filter((item) => !item.contactId == 0)
            ?.map((item) => ({
              UserId: Number(currentUserId),
              ReturnRecordId: true,
              ReturnRecordError: true,
              SaveList: [
                {
                  Id: 0,
                  UserId: Number(currentUserId),
                  InteractUserId: item.contactId,
                  ModifiedBy: Number(currentUserId),
                  fromScreen: "Resume"
                }
              ]
            }));

          await Promise.all(
            interactionRequests.map((interactionObj) =>
              Postrequestcall(SAVE_RECENTLY_INTERACT_USERS, interactionObj, loginData?.accessToken)
            )
          );
        }
        handleClose();
        navigate("/resume-builder");
      }
      setSendLoading(false);
    } catch (error) {
      setSendLoading(false);
      console.log("handleSendResumeBuilder-> Error While Sending Resume: ", error);
    }
  };

  const handleCloseSnackBar = () => {
    setSnackFlag(false);
    setSendingFlag(false);
  };

  const handleSaveResume = async () => {
    if (!pdfTitle.trim()) {
      setPdfTitleError(true);
      return;
    }
    setPdfTitleError(false);

    try {
      setSaveLoading(true);
      const resumeObj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            UserId: Number(currentUserId),
            ResumePdf: props?.resumeData,
            ResumeDate: moment().format("YYYY-MM-DDThh:mm:ss"),
            Title: pdfTitle,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };

      const response = await Postrequestcall(SAVE_USERS_RESUMES, resumeObj, loginData?.accessToken);

      if (response?.data?.status === true) {
        await handleSendResumeBuilder();
        if (props?.fromJob === "apply-job") {
          props?.setOpenResumeBuilder(false);
          props?.fetchResumes();
          props?.loadApi();
          props?.setErrorMessage("");
        } else {
          handleClose();
          navigate("/resume-builder");
        }
      } else {
        setSnackFlag(true);
      }
    } catch (error) {
      console.error(
        "handleSaveResume-> Error saving resume or you might have reached the maximum number of resumes: ",
        error
      );
    } finally {
      setSaveLoading(false);
    }
  };

  const onTutorialClick = () => {
    setTutorialIndex(5);
    return setTutorialType("share-resume-builder");
  };
  const handleClose = () => {
    props?.Close();
    setTutorialIndex(0);
    setPdfTitle("");
    setSelectedEmails([]);
  };
  return (
    <Modal open={props.Open}>
      <Box className="user-modal-responsive2">
        <Box sx={{ width: 500 }}>
          <Snackbar
            autoHideDuration={3000}
            open={snackFlag}
            onClose={handleCloseSnackBar}
            message={sendingFlag ? TEXT_SENDING : TEXT_RESUME_COUNT_ERROR}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            key={"bottomcenter"}
          />
        </Box>
        {tutorialType === "share-resume-builder" && (
          <ShareResumeBuilder
            onPress={() => {
              setTutorialIndex((p) => (p >= 1 ? 0 : p + 1));
            }}
            tutorialIndex={tutorialIndex}
          />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          {
            from == "Resume-List" ?
              <Typography variant="h6">
                {props?.title || ''}
              </Typography> :
              <Typography variant="h6">
                {props?.from == "Add-Resume" ? TEXT_SAVE_RESUME_HEADER : TEXT_SHARERESUME_HEADER}
              </Typography>
          }

          <Stack flexDirection={"row"}>
            {props?.fromJob !== "apply-job" && props?.from === "Add-Resume" && (
              <IconButton onClick={onTutorialClick}>
                <MoreVertIcon />
              </IconButton>
            )}

            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>

            {props?.fromJob === "apply-job" ? (
              <></>
            ) : (
              <IconButton
                loading={saveLoading}
                color="primary"
                onClick={props?.from == "Add-Resume" ? handleSaveResume : handleSendResumeBuilder}
                disabled={
                  props?.from == "Add-Resume"
                    ? !pdfTitle.trim() || sendLoading
                    : selectedEmails.length === 0 || sendLoading
                }>
                {props?.from == "Add-Resume" ? <SaveIcon /> : <SendIcon />}
              </IconButton>
            )}
          </Stack>
        </Box>
        <Grid
          sx={{
            maxHeight: isSmallScreen ? "500px" : isMediumScreen ? "600px" : "100%",
            overflowY: "auto",
            scrollbarWidth: "none"
          }}
          container
          spacing={{ xs: 1, md: 3 }}>
          <Grid size={{ xs: 12, sm: 12, md: 6.5, lg: 6.5, xl: 6.5 }}>
            <Card className="pagelist-content" sx={{ p: 1.5, pt: 0, m: 0 }}>
              <Stack width={"100%"} height={isSmallScreen ? "270px" : "500px"} pt={1.5}>
                <iframe
                  style={{ cursor: "pointer" }}
                  height={"100%"}
                  // src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(props?.resumeData)}#zoom=auto&toolbar=1`}
                  src={`${props?.resumeData}`}
                  title="Resume"
                  allowFullScreen
                />
              </Stack>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}>
            <Stack spacing={2}>
              <Stack spacing={1}>
                <Typography variant="body1" fontWeight={"bold"}>
                  {props?.from === "Add-Resume" || props?.fromJob === "apply-job"
                    ? TEXT_SHARERESUME_TITLE
                    : TEXT_ENTER_TITLE}
                </Typography>
                {props?.from == "Add-Resume" ? (
                  <TextField
                    label={props?.fromJob === "apply-job" ? TEXT_MY_RESUME : TEXT_RESUME_TITLE}
                    size="small"
                    fullWidth
                    value={pdfTitle}
                    error={pdfTitleError}
                    onChange={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                      setPdfTitle(inputValue);
                      setPdfTitleError(false);
                    }}
                  />
                ) : (
                  <Typography variant="body2">{props?.title}</Typography>
                )}
              </Stack>
              {props?.fromJob === "apply-job" ? (
                <></>
              ) : (
                <Stack sx={{ maxHeight: "360px", overflowY: "auto" }}>
                  <ShareModule
                    from="ShareTickets"
                    setSelectedEmails={setSelectedEmails}
                    selectedEmails={selectedEmails}
                  />
                </Stack>
              )}

              {props?.fromJob !== "apply-job" && props?.from === "Add-Resume" && (
                <Button
                  loading={sendLoading}
                  variant="outlined"
                  fullWidth
                  onClick={handleSendResumeBuilder}
                  disabled={selectedEmails.length === 0 || saveLoading}>
                  {TEXT_SEND_RESUME}
                </Button>
              )}

              {props?.fromJob === "apply-job" ? (
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "8px",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    padding: "10px"
                  }}>
                  <Button sx={{ color: "#000", border: "1px solid gray" }} onClick={handleClose}>
                    {BUTTON_BACK}
                  </Button>
                  <Button variant="contained" loading={saveLoading} onClick={handleSaveResume}>
                    {BUTTON_CREATE_RESUME}
                  </Button>
                </Box>
              ) : (
                <></>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ResumeDetailsModal;
